import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { validDecimalAndLength } from '../../ModificationsUtils';

export const ParkingGarageCharges = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const parkingGarageCharge = 'parkingGarageCharge';
  const parkingGarageChargeW: number = useWatch({ name: parkingGarageCharge });
  const isModEdit = useSelector(selectIsEditMod);
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={parkingGarageCharge}
      rules={{
        required: false,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(parkingGarageCharge) ?? ''}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(parkingGarageCharge, validInput);
              onChange(validInput);
            }
          }}
          InputLabelProps={{
            shrink: parkingGarageChargeW ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          variant="filled"
          fullWidth
          id="parkingGarageCharge"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.parkingGarageCharge')}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
